import React, { useEffect, useState, useMemo } from 'react';
import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Card from '@mui/material/Card';
import {orderBy} from 'lodash';

const Assembleias = (params) => {

  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = useMemo(() => `${baseUrl}/content/assembleias`, [baseUrl]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [pages, setPages] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = () => {
      fetch(url, {
        method: 'GET',
        headers: requestHeaders
        })
        .then((response) => response.json())
        .then((result) => {
          setPages(result);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
    fetchData();
  }, [url, requestHeaders]);

  return (
    <div>
        {isLoading
          ?
            <Skeleton sx={{ bgcolor: 'rgba(255, 255, 255, 0.5)' }} variant="rectangular" width={210} height={25} animation="wave" className="skeleton_FE"/>
          :
            <Box className="transparencia_list">
            {orderBy(pages, ['data_hora'], ['desc'])
            .filter(filterPage => (filterPage.Status !== "Planejada"))
            .map(page => (
              <Card className="transparencia_card" key={page.id}>
                <div className="assembleia_item"  key={page.id}>
                  <h4>{page.titulo}</h4>
                  <p>Dia e Horário: {(new Date(page.data_hora)).toLocaleString('pt-BR', { timeZone: 'America/Cuiaba' })}</p>
                  <p>
                    <a className='transparencia_link' href={page.Edital.Url} target="_blank" rel="noreferrer">Edital</a>
                    {page.Ata ?  <> - <a href={page.Ata.Url} target="_blank" rel="noreferrer">Ata</a></> : null}
                  </p>
                </div>
              </Card>
            ))}
            </Box>
        }
    </div>
  );
};

export default Assembleias;

